module.exports = __webpack_public_path__ + "img/game_icon_ownGoal.c717bcee.png";